<nav class="sticky-top">
	<nav class="navbar navbar-dark" style="background: #182c52;">
		<div class="d-flex flex-nowrap w-100 align-items-center justify-content-between">
			<div class="navbar-brand-container">
				<a class="navbar-brand mb-0" [routerLink]="navPath">
					<img src="assets/UCANR_rect_white.png" class="header-logo"
					title="UNIVERSITY OF CALIFORNIA, Agriculture and Natural Resources" alt="UNIVERSITY OF CALIFORNIA, Agriculture and Natural Resources">
				</a>
			</div>

			<div class="navbar-text">
				<ul class="nav justify-content-end">
					<li class="nav-item">
						<user-menu></user-menu>
					</li>
				</ul>
			</div>
		</div>
	</nav>

	<!-- links to be used for both large and small nav menu opts-->
	<ng-template #links>
		<li class="nav-item" *ngFor="let link of navLinks">
			<ng-container [ngSwitch]="link.url == 'SPECIAL___ACADEMIC_REPORT_SUBMISSION'">
					<ng-container *ngSwitchCase="true">
							<academic-report-submission 
								[submissionType]="SubmissionType.ThemesProjectsActivitiesCampusMMP"
								btnClass="btn-sm"
								class="ml-3"
								style="position: relative; top: 8px;">
							</academic-report-submission>
					</ng-container>
					<a mat-button *ngSwitchCase="false" #NavigationLink [routerLink]="link.url" class="nav-link nav-link--with-badge"
						routerLinkActive #rla="routerLinkActive"
						[class.active]="link.active ?? rla.isActive">
						<i [ngClass]="link.iconClass" ></i>&nbsp;{{link.label}}
						<span *ngIf="link.badgeCount > 0" class="nav-link__badge badge badge-primary badge-pill">{{link.badgeCount}}</span>
					</a>
			</ng-container>
		</li>
	</ng-template>

	<nav class="navbar section-header-nav">
		<div [class]="containerClass" class="w-100">
			<div class="row flex-nowrap align-items-center">
				<div class="col-auto">
					<a class="navbar-brand" style="font-size: 1rem; margin-top: 8px;"  [routerLink]="titleLink || navPath" role="link">
						{{sectionTitle}}
					</a>
				</div>
				<div class="col" *ngIf="navLinks.length > 0">
					<div id="mainNavMenu">
						<ul class="nav nav-ribbon-gold" style="margin-bottom: -8px;">
							<ng-template *ngTemplateOutlet="links;"></ng-template>
						</ul>
					</div>
					<div class="menu-container">
						<div id="smallMenu" (click)="menuOpen = !menuOpen">
							<i class="nav-item fa fa-bars"></i>
						</div>
						<div class="menu" [hidden]="!menuOpen" (click)="menuOpen = false">
							<div class="caret"></div>
							<nav class="card nav flex-column">
								<ng-template *ngTemplateOutlet="links;"></ng-template>
							</nav>
						</div>
					</div>
				</div>
			</div>
		</div>
	</nav>
</nav>